export default __webpack_public_path__ + "static/media/apiRefIcon.8386ef7a.png";